import { removeAuthResponseHash } from '@shared/helpers/auth-response-hash/removeAuthResponseHash';

import {
  isSafeRelativeUrl,
  NO_DEEP_LINK_PATHS,
} from './getCurrentDeepLinkUrl.utils';

/** Current in-app location to restore after login. */
export function getCurrentDeepLinkUrl(): string | undefined {
  const { pathname, search, hash } = globalThis.location;
  if (NO_DEEP_LINK_PATHS.includes(pathname)) {
    return undefined;
  }

  const url = removeAuthResponseHash(`${pathname}${search}${hash}`);
  return isSafeRelativeUrl(url) ? url : undefined;
}
